module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teachCenter teachDetail"
  }, [_c('div', {
    staticClass: "crumbs"
  }, [_c('span', [_vm._v("首页")]), _vm._v(">\n    "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'TeachCenter'
      }
    }
  }, [_vm._v("教学中心")])], 1), _vm._v(" >\n    "), _c('span', [_vm._v("医生课程")])]), _vm._v(" "), _c('div', {
    staticClass: "hospital-select"
  }, [_c('div', {
    staticClass: "docBrief"
  }, [(_vm.famousData.photoUrl !== undefined) ? _c('img', {
    staticClass: "iconfont icon-touxiang",
    attrs: {
      "src": _vm.famousData.photoUrl,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "iconfont icon-touxiang",
    attrs: {
      "src": require("../../../../static/image/user.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rtBrief"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "nameColor"
  }, [_vm._v(_vm._s(_vm.famousData.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.famousData.professionTitle))])]), _vm._v(" "), _c('li', {
    staticClass: "difSecond"
  }, [_c('div', {
    staticClass: "hospitalName"
  }, [_vm._v(_vm._s(_vm.famousData.hospitalName))])]), _vm._v(" "), _c('li', [(_vm.famousData.doctorDesc !== undefined) ? _c('p', {
    staticClass: "spilOmit",
    attrs: {
      "title": _vm.famousData.doctorDesc
    }
  }, [_vm._v(_vm._s(_vm.changedoctorDesc))]) : _c('p', {
    staticClass: "spilOmit"
  }, [_vm._v("当前医生暂时没有相关介绍哦")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rtNumber"
  }, [_c('ul', [_c('li', {
    staticClass: "borRight"
  }, [(_vm.famousData.courseCount !== undefined) ? _c('p', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.famousData.courseCount))]) : _c('p', {
    staticClass: "amount"
  }, [_vm._v("0")]), _vm._v(" "), _c('p', [_vm._v("课程数量")])]), _vm._v(" "), _c('li', [(_vm.famousData.lookNumber !== undefined) ? _c('p', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.famousData.lookNumber))]) : _c('p', {
    staticClass: "amount"
  }, [_vm._v("0")]), _vm._v(" "), _c('p', [_vm._v("学习人次")])])])])]), _vm._v(" "), _c('teachCard', {
    attrs: {
      "tecahCardList": _vm.tecahCardList
    },
    on: {
      "popShow": _vm.routerShow1
    }
  }), _vm._v(" "), _c('page', {
    attrs: {
      "total": _vm.page.total,
      "allPage": _vm.page.allPage,
      "currentPage": _vm.page.currentPage,
      "current": 'tenchCenter',
      "pageSize2": _vm.page.pageSize
    },
    on: {
      "current-page": _vm.__currentPage,
      "page-size": _vm.__pageSize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-29f8578a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/teachCenter/TeachDetail.vue
// module id = 544
// module chunks = 1 2 3 4 5 6 7 8